import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import { COOKIES_CONFIG } from '../configs/cookies.config';
import { DataCacheService } from './data-cache.service';
import { ApiActionLogsService } from './api-call-providers/api-action-logs.service';


@Injectable()
export class ActionLogsService {

  private modelSource = new Subject<any>();
  list = this.modelSource.asObservable();;

  // 睡眠センサーのログ
  private sleepLogsSource = new Subject<any>();
  sleepLogs$ = this.sleepLogsSource.asObservable();;

  // ナースコールのログ
  private nurseCallLogsSource = new Subject<any>();
  nurseCall$ = this.nurseCallLogsSource.asObservable();;

  constructor(
    private _dataCacheService: DataCacheService,
    private _ApiActionLogsService: ApiActionLogsService,
  ) {
  }

  get loading() {
    return this._ApiActionLogsService.isLoading
  }

  /**
   * データの初期化
   */
  async load(params = {}) {
    this._ApiActionLogsService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.NEWS_DATA)
    if (!_data.isExist()) {
      await this.fetch(params);
      return
    }
    this._ApiActionLogsService.isLoading = false
    return this.modelSource.next(_data);
  }

  /**
   * 
   */
  async fetch(params = {}) {
    let res: any = await this._ApiActionLogsService.list(params);
    let data:any = { data: res.list, paging: res.paging };
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.NEWS_DATA, res.list, res.expired)
    }
    this.modelSource.next(data)
  }



  // ********************************************
  // * 睡眠センサーのログを取得する処理
  // ********************************************
  async fetchSleepLogs(params = {}) {
    let res: any = await this._ApiActionLogsService.listSleepLogs(params);
    let data:any = { data: res.list, paging: res.paging };
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.SLEEP_SENSOR_LOGS, res.list, res.expired)
    }
    this.sleepLogsSource.next(data)
  }

  // ********************************************
  // * ナースコールのログを取得する処理
  // ********************************************
  async fetchNurseCallLogs(params = {}) {
    let res: any = await this._ApiActionLogsService.listNurseCallLogs(params);
    let data:any = { data: res.list, paging: res.paging };
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.NURSE_CALL_LOGS, res.list, res.expired)
    }
    this.nurseCallLogsSource.next(data)
  }
}



// WEBPACK FOOTER //
// ./src/providers/action-logs.service.ts